import React, { useRef, useState } from 'react';
import InputTitleView from './InputTitleView';
import icUpload from 'Assets/img/recruitment/ic_upload.png';
import icUpload2 from 'Assets/img/recruitment/ic_upload@2x.png';
import icUpload3 from 'Assets/img/recruitment/ic_upload@3x.png';
import icDelete from 'Assets/img/recruitment/ic_delete.png';
import icDelete2 from 'Assets/img/recruitment/ic_delete@2x.png';
import icDelete3 from 'Assets/img/recruitment/ic_delete@3x.png';
import { getFileName, getImageSet } from 'Util/DataUtils';
import IntlMessages from 'Util/IntlMessages';
import { uploadFileApplyMyFiles } from 'Api/endpoints/Recruitment';
import { saveAs } from 'file-saver';
import { CircularProgress } from '@mui/material';
import { useError } from 'Api/hooks/useError';

const uploads = getImageSet([icUpload, icUpload2, icUpload3]);
const deleteButtons = getImageSet([icDelete, icDelete2, icDelete3]);
const FileInputView = ({ title = '', required = false, subTitle = '', name, value, onChange }) => {
  const inputRef = useRef();
  const [loading, setLoading] = useState(false);
  const { showErrorPopup } = useError();

  const uploadImage = async image => {
    try {
      const result = await uploadFileApplyMyFiles(image);
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return null;
      }
      return result.data.image.origin_path;
    } catch (e) {
      console.log(e);
    }
  };

  const onChangeImage = async e => {
    const image = e.target.files[0];
    if (!image) return null;
    setLoading(true);
    const result = await uploadImage(image);
    if (result) {
      onChange({ name, value: result });
    }
    setLoading(false);
  };

  return (
    <div className="recruitment-file-input-view">
      <InputTitleView title={title} required={required} subTitle={subTitle} />
      {value ? (
        <div className="recruitment-file-input-view-data">
          <div className="recruitment-file-input-view-data-value" onClick={() => saveAs(value, getFileName(value))}>
            {getFileName(value)}
          </div>
          <img {...deleteButtons} alt="delete" onClick={() => onChange({ name, value: '' })} />
        </div>
      ) : loading ? (
        <div className="recruitment-file-input-view-input">
          <CircularProgress size={24} />
        </div>
      ) : (
        <>
          <input type="file" ref={inputRef} onChange={onChangeImage} accept="image/*, .pdf" style={{ display: 'none' }} />
          <div
            className="recruitment-file-input-view-input"
            onClick={() => {
              inputRef.current.click();
            }}
          >
            <img {...uploads} alt="upload" />
            <div className="recruitment-file-input-view-input-text">
              <IntlMessages id="common.fileUpload.text" />
            </div>
            <div className="recruitment-file-input-view-input-sub-text">
              <IntlMessages id="common.fileUpload.subText" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FileInputView;
